<template>
  <div :class="spinnerClass" role="status">
    <span v-if="label" class="sr-only">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'BSpinnerKariermu',
  props: {
    variant: {
      type: String,
      validator: (value) =>
        ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'].includes(value)
    },
    type: {
      type: String,
      default: 'border',
      validator: (value) => ['border', 'grow'].includes(value)
    },
    label: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    smallClass () {
      if (this.small) {
        return this.type === 'border' ? 'spinner-border-sm' : 'spinner-grow-sm'
      } else {
        return ''
      }
    },
    variantClass () {
      if (this.variant) {
        return `text-${this.variant}`
      } else {
        return ''
      }
    },
    spinnerClass () {
      return `spinner-${this.type} ${this.smallClass} ${this.variantClass}`
    }
  }
}
</script>
